import React, { useEffect, useState, useMemo } from 'react';
import './MilestoneTable.less';
import {
  useHistory, useParams, Link, useLocation,
} from 'react-router-dom';
import MaterialTable from 'material-table';
import { HelpOutline, History } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import { Button, Image } from 'react-bootstrap';
import Select from 'react-select';
import useAPI from '../../../../hooks/useAPI';
import { monthsArray } from '../../../../stores/StratProject/StrategyStore';
import {
  arrayToLookup, getResultImpactLabel, localization, modifyDefaultOptions,
  sortMilestonesByFactDateDesc,
} from '../../../../helpers/table';
import TableAction from '../../../strategyProject/tabs/TabResults/TableAction/TableAction';
import fileIcon from '../../../../../img/icons/FileTableIcon.svg';
import MilestoneFilesModal from '../../PassportRead/MilestoneFilesModal';
import { tableIcons, years } from '../../../../helpers';
import TooltippedElement from '../../../common/TooltippedElement';
import StatusBadge from '../../../common/StatusBadge';
import FilterMultiSelect from '../../../table/FilterMultiSelect';
import { MILESTONE_STATUSES_RU } from '../../../../helpers/report';
import { BaseRequests } from '../../../../requests/BaseRequests';
import LoadingTable from '../../../table/LoadingTable';
import useUserContext from '../../../../hooks/useUserContext';
import {
  isAdminReadRestricted, isPortfolioTeam, isProjectTeam, isStrategyTeam,
} from '../../../../services/rolesSvc';

import { MilestoneActions } from './MilestoneActions';
import ModalSendForRevision from '../../../common/ModalSendForRevision';
import ConfirmModal from '../../../common/ConfirmModal';
import { useRequestObject } from '../../../../hooks/useRequestObject';
import useToast from '../../../../hooks/useToast';
import ApproveMilestoneModal from './ApproveMilestoneModal';
import NotApprovedMilestoneModal from './NotApproveMilestoneModal';
import { getSectionLinkPart } from '../../../../helpers/typeProject';

const updateTableData = (ent, data) => {
  const dataCopy = [...data];
  let tm = dataCopy.find((t) => t.originId === ent.id);
  Object.assign(tm, ent);
  return dataCopy;
};

export default function MilestonesTable() {
  const [pageTitle, setPageTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [initialMilestones, setInitialMilestones] = useState([]);
  const [filesModalVisible, setFilesModalVisible] = useState(false);
  const [activeMilestone, setActiveMilestone] = useState({});
  const [trls, setTrls] = useState([]);
  const [resultImpact, setResultImpact] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [navContext, setNavContext] = useState({});
  const history = useHistory();
  const location = useLocation();
  const api = useAPI();
  const {
    projId, stratId, portfolioId, policyId,
  } = useParams();
  const userCtx = useUserContext();
  const addToast = useToast();

  const sectionLinkPart = useMemo(() => getSectionLinkPart(location.pathname), [location.pathname]);

  const [isModalReject, setIsModalReject] = useState({
    show: false,
    value: null,
  });
  const [isModalApprove, setIsModalApprove] = useState({
    show: false,
    value: null,
  });
  const [notApproveMessage, setNotApproveMessage] = useState(null);

  const requests = {
    getAsNews: (id) => {
      const result = api.get(`/news/milestone/${id}`);
      return result;
    },

    send: async (ent) => {
      const result = await api.post(`/projs/${ent.projId}/milestones/${ent.id}/send`);
      if (result && !result.error) {
        setInitialMilestones((prevState) => updateTableData({ id: result.id, status: result.status }, prevState));
        addToast.success('Веха отправлена на согласование');
        return true;
      } else return false;
    },
    reject: async (ent, comment) => {
      const result = await api.post(`/projs/${ent.projId}/milestones/${ent.id}/reject`, { comment });
      if (result && !result.error) {
        setInitialMilestones((prevState) => updateTableData({ id: result.id, status: result.status, comment }, prevState));
        addToast.success('Веха не согласована');
        return true;
      } else return false;
    },

    approve: async (ent, news, image) => {
      const result = await api.postFileFixed(`/projs/${ent.projId}/milestones/${ent.id}/approve`, news, image);
      if (result && !result.error) {
        setInitialMilestones((prevState) => updateTableData({ id: result.id, status: result.status }, prevState));
        addToast.success('Веха согласована');
        addToast.success('Веха опубликована в разделе «Новости»');
      } else return false;
    },
  };

  const getLink = (ent) => {
    const sId = ent.proj?.stratId ?? stratId;
    const polId = ent.proj?.policyId ?? policyId;
    const porId = ent.proj?.portfId ?? portfolioId;
    const pId = ent.proj?.id ?? projId;

    return !!sId
      ? `/${sectionLinkPart}/${sId}${
        porId
          ? `/portfolios/${porId}`
          : ''
      }/projs/${pId}/report/milestone/${ent.id}/edit`
      : `/${sectionLinkPart}/${polId}/projs/${pId
      }/report/milestone/${ent.id}/edit`;
  };

  const milestones = useMemo(() => [...initialMilestones].sort(sortMilestonesByFactDateDesc), [initialMilestones]);

  const canEdit = useMemo(
    () =>
      (
        isStrategyTeam(userCtx, stratId)
        || (projId && isProjectTeam(userCtx, projId))
        || (portfolioId && isPortfolioTeam(userCtx, portfolioId))
        || isAdminReadRestricted(userCtx)
      ),
    [userCtx],
  );

  useEffect(async () => {
    const trls = await api.get('/mng/trls');
    setTrls(trls);
    if (projId && stratId) {
      const resultsImpact = await api.get(`/strategies/${stratId}/results/0/findByProj?projId=${projId}`);
      setResultImpact(resultsImpact);
    }
  }, []);

  useEffect(async () => {
    let portfolio = {};
    if (portfolioId) {
      portfolio = await api.get(
        `/structure/portfolios/${portfolioId}`,
      );
      setNavContext((prev) => ({ ...prev, portfolioId: portfolio.originId }));
    }
    if (projId) {
      const project = await api.get(
        `/structure/projs/${projId}`,
      );
      setNavContext((prev) => ({ ...prev, projId: project.originId }));
      setPageTitle('Вехи проекта');
    } else if (portfolioId) {
      setSubtitle(portfolio.name);
    } else if (policyId) {
      const policy = await api.get(`/mng/strategies/${policyId}`);
      setSubtitle(policy.name);
    } else if (stratId) {
      const stratProj = await api.get(`/mng/strategies/${stratId}`);
      setSubtitle(`${stratProj.num}. ${stratProj.name}`);
    }
    if (!projId && (stratId || policyId || portfolioId)) {
      setPageTitle('Вехи проектов для публикации в СМИ');
    }
  }, [stratId, projId, portfolioId, policyId]);

  useEffect(async () => {
    let link = '/news/newsbreak';
    if (projId) {
      link = BaseRequests.getUrlSearch(`/projs/${projId}/milestones`, {
        year,
        month,
      });
    } else if (stratId || policyId) {
      link = BaseRequests.getUrlSearch('/reports/milestones', {
        strategyId: stratId,
        portfId: portfolioId,
        policyId,
        year,
        month,
      });
    } else {
      link = BaseRequests.getUrlSearch(link, {
        year,
        month,
      });
    }
    const milestones = await api.get(link);
    setInitialMilestones(milestones.filter((milestone) => milestone.publishInMedia || projId).sort((a, b) => a.yearPlan - b.yearPlan || a.monthPlan - b.monthPlan));
    setIsLoading(false);
  }, [year, month, projId]);

  const handleReject = async (comment) => {
    await requests.reject(isModalReject.value, comment);
    setIsModalReject({ show: false, value: null });
  };
  const handleApprove = () => {
    const ent = isModalApprove.value;
    history.push(`/news/edit/new?milestone=${ent.id}&projId=${ent.projId}&portfId=${ent.proj?.portfId ?? portfolioId ?? 0}&policyId=${ent.proj?.policyId ?? policyId ?? 0}&strategyId=${ent.proj?.strategyId ?? stratId ?? 0}`);
  };
  const handleApproveWithoutNews = async () => {
    await requests.approve(isModalApprove.value, {}, null);
    setIsModalApprove({ show: false, value: null });
  };

  const actions = {
    edit: (id, rowData) => history.push(getLink(rowData)),
    send: (id, rowData) => requests.send(rowData),
    approve: (id, rowData) => setIsModalApprove({ show: true, value: rowData }),
    reject: (id, rowData) => setIsModalReject({ show: true, value: rowData }),
  };

  const columns = useMemo(() => {
    const actionsAndStatusColumns = [
      {
        title: 'Действ',
        render: (rowData) => (
          <div className="d-flex align-items-center gap-3">
            {/* <Tooltip title="История версий">
              <History style={{ color: '#0D6EFD' }} />
            </Tooltip> */}
            <MilestoneActions
              props={rowData}
              actions={actions}
              userCtx={userCtx}
              navCtx={{
                stratId, policyId, portfolioId: navContext.portfolioId || portfolioId, projId: navContext.projId || projId,
              }}
            />
          </div>
        ),
      },
      {
        title: 'Статус',
        field: 'status',
        lookup: arrayToLookup(
          'status',
          milestones.map((milestone) => ({
            ...milestone,
            status: MILESTONE_STATUSES_RU[milestone.status || MILESTONE_STATUSES_RU.new.key].label,
          })),
        ),
        filterComponent: FilterMultiSelect,
        render: (rowData) => (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <StatusBadge type="milestones" status={rowData.status || MILESTONE_STATUSES_RU.new.key} />
            {rowData.status === MILESTONE_STATUSES_RU.notApproved.key && <HelpOutline style={{ width: 16, cursor: 'pointer' }} onClick={() => setNotApproveMessage(rowData.comment || '...')} />}
          </div>
        ),
        customFilterAndSearch: (term, rowData) =>
          term.length === 0
            || term.includes(MILESTONE_STATUSES_RU[rowData.status].label),
        cellStyle: {
          minWidth: 180,
        },
      },
    ];
    const topLevelColumns = [
      !stratId && !policyId && {
        title: '№ и название СП/цели',
        field: 'stratProj',
        render: (rowData) =>
          (rowData.proj?.strategyId
            ? `${rowData.proj?.strategyNum} ${rowData.proj?.strategyName}`
            : '-'),
        lookup: arrayToLookup(
          'SPname',
          milestones.map((milestone) => ({
            SPname: milestone.proj?.strategyId
              ? `${milestone.proj?.strategyNum} ${milestone.proj?.strategyName}`
              : '-',
          })),
        ),
        filterComponent: FilterMultiSelect,
        customFilterAndSearch: (term, rowData) =>
          term.length === 0
          || term.includes(
            `${rowData.proj?.strategyNum} ${rowData.proj?.strategyName}`,
          ),
      },
      !stratId && !policyId && {
        title: 'Руководитель СП/Цели, Контакты',
        field: 'stratProj',
        render: (rowData) => (
          <p>
            {getName(rowData.proj?.strategyHead)}
            <br />
            {rowData.proj?.strategyHead?.email || ''}
          </p>
        ),
        lookup: arrayToLookup(
          'stratHeadName',
          milestones.map((milestone) => ({
            stratHeadName: getName(milestone.proj?.strategyHead),
          })),
        ),
        filterComponent: FilterMultiSelect,
        customFilterAndSearch: (term, rowData) =>
          term.length === 0
          || term.includes(
            getName(rowData.proj?.strategyHead),
          ),
      },
    ];
    const middleLevelColumns = [
      !projId && {
        title: '№ и название проекта',
        field: 'project',
        cellStyle: {
          minWidth: 230,
        },
        render: (rowData) => {
          const projName = `${rowData.proj?.fullNumber} ${rowData.proj?.name}`;
          return (
            <Link
              to={`/${
                rowData.proj.strategyId
                  ? `strats/${rowData.proj.strategyId}`
                  : `policies/${rowData.proj.policyId}`
              }/${
                rowData.proj.portfId
                  ? `portfolios/${rowData.proj.portfId}/projs/${rowData.proj.id}`
                  : `projs/${rowData.proj.id}`
              }`}
            >
              {projName.length > 80
                ? `${projName.substring(0, 80)}...`
                : projName}
            </Link>
          );
        },
        filterComponent: FilterMultiSelect,
        lookup: arrayToLookup(
          'name',
          milestones.map((milestone) => ({
            name: `${milestone.proj?.fullNumber} ${milestone.proj?.name}`,
          })),
        ),
        customFilterAndSearch: (term, rowData) =>
          term.length === 0
            || term.includes(
              `${rowData.proj?.fullNumber} ${rowData.proj?.name}`,
            ),
        filterCellStyle: {
          maxWidth: 300,
        },
      },
      !projId && {
        title: 'Руководитель',
        field: 'projectHead',
        cellStyle: {
          minWidth: 152,
        },
        render: (rowData) => rowData.proj?.head?.displayName,
        filterComponent: FilterMultiSelect,
        lookup: arrayToLookup(
          'displayName',
          milestones.map((milestone) => milestone.proj?.head),
        ),
        customFilterAndSearch: (term, rowData) =>
          term.length === 0
            || term.includes(rowData.proj?.head.displayName),
        filterCellStyle: {
          maxWidth: 200,
        },
      },
    ];
    const milestoneColumns = [
      {
        title: 'Выдающийся результат/веха СП, на который влияет проект',
        field: 'stratResultId',
        cellStyle: {
          minWidth: 200,
        },
        render: (rowData) => getResultImpactLabel(rowData.stratResultId, resultImpact),
        filtering: false,
        hidden: !(stratId && projId),
      },
      {
        title: 'Веха',
        field: 'name',
        cellStyle: {
          minWidth: 305,
          padding: '8px 16px',
        },
        filtering: false,
      },
      {
        title: 'Достижение вехи',
        field: 'result',
        cellStyle: {
          minWidth: 370,
          padding: '8px 16px',
        },
        filterCellStyle: {
          maxWidth: 370,
        },
        lookup: arrayToLookup('result', milestones),
        filterComponent: FilterMultiSelect,
        render: (rowData) => <div>{rowData.result || '-'}</div>,
      },
      {
        title: 'Дата вып. (план)',
        field: 'planDate',
        cellStyle: {
          minWidth: 160,
        },
        lookup: arrayToLookup('planDate', milestones.map((milestone) => ({ planDate: `${monthsArray[milestone.monthPlan - 1]}, ${milestone.yearPlan}` }))),
        filterComponent: FilterMultiSelect,
        customFilterAndSearch: (term, rowData) => term.length === 0 || term.includes(`${monthsArray[rowData.monthPlan - 1]}, ${rowData.yearPlan}`),
        render: (rowData) => (
          <div>
            {monthsArray[rowData.monthPlan - 1]}
            ,
            {' '}
            {rowData.yearPlan}
          </div>
        ),
      },
      {
        title: 'Дата вып. (факт)',
        field: 'factDate',
        cellStyle: {
          minWidth: 160,
        },
        lookup: arrayToLookup('factDate', milestones.map((milestone) => ({ factDate: milestone.monthFact ? `${monthsArray[milestone.monthFact - 1]}, ${milestone.yearFact}` : '-' }))),
        filterComponent: FilterMultiSelect,
        customFilterAndSearch: (term, rowData) => term.length === 0 || term.includes(rowData.monthFact ? `${monthsArray[rowData.monthFact - 1]}, ${rowData.yearFact}` : '-'),
        render: (rowData) => <div>{rowData.monthFact ? `${monthsArray[rowData.monthFact - 1]}, ${rowData.yearFact}` : '-'}</div>,
      },
      {
        title: 'УГТ (план)',
        field: 'trlId',
        cellStyle: {
          minWidth: 140,
        },
        render: (rowData) => (
          <div>
            {rowData.trlId
              ? <TooltippedElement iconSize="16px" tooltip={trls.find((trl) => trl.id === rowData.trlId)?.descr}>{rowData.trlId}</TooltippedElement>
              : '-'}
          </div>
        ),
        filterComponent: FilterMultiSelect,
        lookup: arrayToLookup('trlId', milestones),
      },
      {
        title: 'УГТ (факт)',
        field: 'trlFactId',
        cellStyle: {
          minWidth: 140,
        },
        render: (rowData) => (
          <div>
            {rowData.trlFactId
              ? <TooltippedElement iconSize="16px" tooltip={trls.find((trl) => trl.id === rowData.trlFactId)?.descr}>{rowData.trlFactId}</TooltippedElement>
              : '-'}
          </div>
        ),
        filterComponent: FilterMultiSelect,
        lookup: arrayToLookup('trlFactId', milestones),
      },
      {
        title: 'Ответственный',
        field: 'personsInCharge',
        cellStyle: {
          minWidth: 170,
        },
        render: (rowData) => (rowData.personsInCharge && rowData.personsInCharge[0]
          ? `${rowData.personsInCharge[0].displayName}, ${rowData.personsInCharge[0].post}`
          : '-'),
        filterComponent: FilterMultiSelect,
        lookup: arrayToLookup('displayName', milestones.map((milestone) => (milestone.personsInCharge && milestone.personsInCharge[0]
          ? milestone.personsInCharge[0]
          : { displayName: '-' }))),
        customFilterAndSearch: (term, rowData) => term.length === 0 || term.includes(rowData.personsInCharge && rowData.personsInCharge[0]
          ? rowData.personsInCharge[0].displayName
          : '-'),
      },
      {
        title: 'Документы',
        field: 'files',
        render: (rowData) => (
          <div
            className="d-flex align-items-center gap-1"
            style={{ color: '#0D6EFD', cursor: 'pointer' }}
            onClick={() => {
              setActiveMilestone(rowData);
              setFilesModalVisible(true);
            }}
          >
            <Image src={fileIcon} style={{ width: 16 }} />
            {rowData.files?.length ?? 0}
          </div>
        ),
        filtering: false,
      },
    ];
    const portfolioColumn = {
      title: 'Портфель',
      field: 'portfolio',
      cellStyle: {
        minWidth: 200,
      },
      render: (rowData) => rowData.proj?.portfName || '-',
      lookup: arrayToLookup(
        'portfName',
        milestones.map((milestone) => ({
          portfName: milestone.proj?.portfName || '-',
        })),
      ),
      filterComponent: FilterMultiSelect,
      customFilterAndSearch: (term, rowData) =>
        term.length === 0 || term.includes(rowData.proj?.portfName || '-'),
    };
    const publishInMediaColumn = {
      title: 'Опубликовать в СМИ',
      field: 'publishInMedia',
      render: (rowData) => (rowData.publishInMedia ? 'Да' : 'Нет'),
      filtering: true,
      filterComponent: FilterMultiSelect,
      lookup: arrayToLookup(
        'publishInMedia',
        milestones.map((milestone) => ({
          ...milestone,
          publishInMedia: milestone.publishInMedia ? 'Да' : 'Нет',
        })),
      ),
      customFilterAndSearch: (term, rowData) =>
        term.length === 0
          || term.includes(!!rowData.publishInMedia ? 'Да' : 'Нет'),
    };
    return projId
      ? [...actionsAndStatusColumns, ...milestoneColumns, publishInMediaColumn]
      : policyId
        ? [
          ...actionsAndStatusColumns,
          ...middleLevelColumns,
          ...milestoneColumns,
			  ]
        : stratId
          ? [
            ...actionsAndStatusColumns,
            ...middleLevelColumns,
            ...milestoneColumns,
            portfolioColumn,
          ]
          : [
            ...actionsAndStatusColumns,
            ...topLevelColumns,
            ...middleLevelColumns,
            ...milestoneColumns,
            portfolioColumn,
          ];
  }, [stratId, projId, portfolioId, policyId, milestones, navContext]);

  return (
    <LoadingTable
      spinnerStyle={{ marginTop: 30 }}
      loadingObject={{ isLoading }}
    >
      <div className="milestoneTable">
        {pageTitle && (
          <h1
            className="milestoneTable-title"
            style={{ marginBottom: projId ? 27 : 4 }}
          >
            {pageTitle}
          </h1>
        )}
        {subtitle && <h2 style={styledSubtitle}>{subtitle}</h2>}
        <div className="d-flex gap-3">
          <div className="milestoneTable-year">
            <h2>Год</h2>
            <Select
              options={[
                notSelectedOption,
                ...years.map((year) => ({ label: year, value: year })),
              ]}
              onChange={(event) => setYear(event.value)}
              defaultValue={notSelectedOption}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 10 }),
                // menu: base => ({ ...base, color: '#222' }),
              }}
            />
          </div>
          <div className="milestoneTable-year">
            <h2>Месяц</h2>
            <Select
              options={[
                notSelectedOption,
                ...monthsArray.map((month, i) => ({
                  label: month,
                  value: i + 1,
                })),
              ]}
              onChange={(event) => setMonth(event.value)}
              defaultValue={notSelectedOption}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 10 }),
                // menu: base => ({ ...base, color: '#222' }),
              }}
            />
          </div>
        </div>
        <div>
          <MaterialTable
            columns={columns}
            icons={tableIcons}
            data={milestones}
            localization={localization}
            options={modifyDefaultOptions({
              toolbar: false,
              paging: false,
              sorting: false,
              draggable: false,
              filtering: true,
              maxBodyHeight: 'calc(100vh - 442px)',
              headerStyle: {
                fontSize: 12,
                lineHeight: 1.3,
                padding: '8px 16px',
                zIndex: 0,
                fontFamily: 'inherit',
                position: 'sticky',
                backgroundColor: '#fff',
                zIndex: 2,
              },
              actionsCellStyle: {
                maxWidth: 100,
                textAlign: 'center',
              },
              filterCellStyle: {
                position: 'sticky',
                top: projId || !stratId && !policyId && !portfolioId ? 53 : 34,
                backgroundColor: '#fff',
                zIndex: 2,
              },
              rowStyle: {
                whiteSpace: 'pre-wrap',
              },
            })}
          />
        </div>
        <MilestoneFilesModal
          files={activeMilestone.files ?? []}
          show={filesModalVisible}
          onHide={() => setFilesModalVisible(false)}
        />
        <ModalSendForRevision
          show={isModalReject.show}
          onClose={() => setIsModalReject({ show: false, value: null })}
          onSubmit={(comment) => handleReject(comment)}
          headerText="Не согласовать"
          label="Комментарий"
        />
        <ApproveMilestoneModal
          show={isModalApprove.show}
          onClose={() => setIsModalApprove({ show: false, value: null })}
          onReject={() => handleApproveWithoutNews()}
          onConfirm={() => handleApprove()}
        />
        <NotApprovedMilestoneModal
          show={!!notApproveMessage}
          onHide={() => setNotApproveMessage(null)}
          message={notApproveMessage}
        />
      </div>
    </LoadingTable>
  );
}

const notSelectedOption = { label: 'Не указан', value: null };

const styledSubtitle = {
  fontSize: 24,
  marginTop: 0,
  marginBottom: 44,
  textAlign: 'left',
  color: '#0C0065',
};
const getName = (person) => (person.lastName
  ? `${person.lastName} ${
    person.firstName[0]}. ${
    person.middleName
      ? `${person.middleName[0]}.`
      : ''}`
  : '-');
